import { useEffect, useCallback } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import Login from "./pages/Login";
import Main from "./pages/Main";
import DeviceSetup from "./pages/DeviceSetup";
import { useAuth } from "./context/AuthContext";

const App = () => {
  const { loggedIn } = useAuth();
  const navigate = useNavigate();

  const checkLoggedIn = useCallback(() => {
    if (!loggedIn) {
      navigate("/login");
    } else {
      navigate("/");
    }
  }, [loggedIn, navigate]);

  useEffect(() => {
    const currentPath = window.location.pathname;
    if (currentPath !== "/device-setup") {
      checkLoggedIn();
    }
  }, [checkLoggedIn]);

  return (
    <div className="app">
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/login" element={<Login />} />
        <Route path="/device-setup" element={<DeviceSetup />} />
      </Routes>
    </div>
  );
};

export default App;
